var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-sheet",
    { staticClass: "rounded-xl my-6 checkout-page-container" },
    [
      _c(
        "div",
        { staticClass: "scrolling-content" },
        [
          _c(
            "v-container",
            { staticClass: "py-12" },
            [
              _vm.isLoading
                ? _c(
                    "div",
                    { staticClass: "text-center pa-16" },
                    [
                      _c("v-progress-circular", {
                        attrs: {
                          indeterminate: "",
                          color: "primary",
                          size: "64",
                        },
                      }),
                      _c("p", { staticClass: "mt-4 text--secondary" }, [
                        _vm._v(_vm._s(_vm.$t("PaymentPage.Checkout.loading"))),
                      ]),
                    ],
                    1
                  )
                : _vm.selectedPlan
                ? _c(
                    "div",
                    {
                      staticStyle: { "max-width": "1100px", margin: "0 auto" },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "text-center mb-10" },
                        [
                          _c(
                            "h1",
                            {
                              staticClass:
                                "text-h4 font-weight-bold grey--text text--darken-3",
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("PaymentPage.Checkout.title"))
                              ),
                            ]
                          ),
                          _c("p", { staticClass: "text--secondary mt-2" }, [
                            _vm._v(
                              _vm._s(_vm.$t("PaymentPage.Checkout.description"))
                            ),
                          ]),
                          _vm.isLocalPaymentBypassEnabled
                            ? _c(
                                "v-chip",
                                {
                                  staticClass: "mt-3 font-weight-bold",
                                  attrs: { color: "warning", outlined: "" },
                                },
                                [
                                  _c(
                                    "v-icon",
                                    { attrs: { left: "", small: "" } },
                                    [_vm._v("mdi-flask-outline")]
                                  ),
                                  _vm._v(" LOCAL TEST MODE "),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                      _c(
                        "v-row",
                        [
                          _c(
                            "v-col",
                            { attrs: { cols: "12", md: "7" } },
                            [
                              _c(
                                "v-card",
                                {
                                  staticClass: "pa-6 rounded-lg",
                                  attrs: { outlined: "" },
                                },
                                [
                                  _c(
                                    "h2",
                                    {
                                      staticClass:
                                        "text-h6 font-weight-semibold mb-6 d-flex align-center",
                                    },
                                    [
                                      _c(
                                        "v-icon",
                                        {
                                          attrs: { left: "", color: "primary" },
                                        },
                                        [_vm._v("mdi-credit-card-outline")]
                                      ),
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t(
                                              "PaymentPage.Checkout.paymentMethod"
                                            )
                                          ) +
                                          " "
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "p",
                                    { staticClass: "text--secondary mb-6" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "PaymentPage.Checkout.secureToss"
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                  _c("div", {
                                    attrs: { id: "payment-widget" },
                                  }),
                                  _c("div", {
                                    staticClass: "mt-4",
                                    attrs: { id: "payment-agreement" },
                                  }),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { cols: "12", md: "5" } },
                            [
                              _c(
                                "v-card",
                                {
                                  staticClass: "pa-6 rounded-lg",
                                  staticStyle: {
                                    position: "sticky",
                                    top: "90px",
                                  },
                                  attrs: { outlined: "" },
                                },
                                [
                                  _c(
                                    "h2",
                                    {
                                      staticClass:
                                        "text-h6 font-weight-semibold mb-4",
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "PaymentPage.Checkout.orderSummary"
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "v-list",
                                    {
                                      attrs: {
                                        dense: "",
                                        color: "transparent",
                                      },
                                    },
                                    [
                                      _c(
                                        "v-list-item",
                                        { staticClass: "px-0" },
                                        [
                                          _c(
                                            "v-list-item-content",
                                            [
                                              _c(
                                                "v-list-item-title",
                                                {
                                                  staticClass:
                                                    "text--secondary",
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "PaymentPage.Checkout.basePlan",
                                                        {
                                                          planName:
                                                            _vm.selectedPlan
                                                              .name,
                                                        }
                                                      )
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-list-item-action-text",
                                            {
                                              staticClass: "font-weight-medium",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.formatPrice(
                                                    _vm.planPriceKrw
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm.hasCircuitModule
                                        ? _c(
                                            "v-list-item",
                                            { staticClass: "px-0" },
                                            [
                                              _c(
                                                "v-list-item-content",
                                                [
                                                  _c(
                                                    "v-list-item-title",
                                                    {
                                                      staticClass:
                                                        "text--secondary",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "PaymentPage.Checkout.circuitAddon"
                                                          )
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-list-item-action-text",
                                                {
                                                  staticClass:
                                                    "font-weight-medium",
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.formatPrice(
                                                        _vm.circuitPriceKrw
                                                      )
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm.extraUsersCount > 0
                                        ? _c(
                                            "v-list-item",
                                            { staticClass: "px-0" },
                                            [
                                              _c(
                                                "v-list-item-content",
                                                [
                                                  _c(
                                                    "v-list-item-title",
                                                    {
                                                      staticClass:
                                                        "text--secondary",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "PaymentPage.Checkout.additionalUsers",
                                                            {
                                                              count:
                                                                _vm.extraUsersCount,
                                                            }
                                                          )
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-list-item-action-text",
                                                {
                                                  staticClass:
                                                    "font-weight-medium",
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.formatPrice(
                                                        _vm.extraUsersPriceKrw
                                                      )
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                  _c("v-divider", { staticClass: "my-4" }),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "d-flex justify-space-between align-center",
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "text-h6 font-weight-bold grey--text text--darken-4",
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "PaymentPage.Checkout.totalDue"
                                              )
                                            )
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "text-h6 font-weight-bold primary--text",
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.formatPrice(
                                                _vm.totalAmountKrw
                                              )
                                            )
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "text-right text--secondary text-caption mt-1",
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t(
                                              "PaymentPage.Checkout.vatIncluded",
                                              {
                                                exchangeRate:
                                                  _vm.exchangeRateDisplay,
                                              }
                                            )
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "v-btn",
                                    {
                                      staticClass: "mt-6",
                                      attrs: {
                                        disabled: !_vm.isWidgetReady,
                                        loading: _vm.isLoading,
                                        color: "primary",
                                        block: "",
                                        "x-large": "",
                                        depressed: "",
                                      },
                                      on: { click: _vm.requestPayment },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t(
                                              "PaymentPage.Checkout.confirmAndPay",
                                              {
                                                amount: _vm.formatPrice(
                                                  _vm.totalAmountKrw
                                                ),
                                              }
                                            )
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                  _vm.isLocalPaymentBypassEnabled
                                    ? _c(
                                        "v-btn",
                                        {
                                          staticClass: "mt-3",
                                          attrs: {
                                            color: "warning",
                                            outlined: "",
                                            block: "",
                                            large: "",
                                          },
                                          on: {
                                            click:
                                              _vm.skipPaymentForLocalTesting,
                                          },
                                        },
                                        [_vm._v(" Skip Payment (Local) ")]
                                      )
                                    : _vm._e(),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "text-center mt-4 text--disabled text-caption",
                                    },
                                    [
                                      _c(
                                        "v-icon",
                                        { attrs: { small: "", left: "" } },
                                        [_vm._v("mdi-lock-outline")]
                                      ),
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t(
                                              "PaymentPage.Checkout.secureTransaction"
                                            )
                                          ) +
                                          " "
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _c(
                    "v-alert",
                    {
                      staticClass: "mx-auto",
                      attrs: {
                        type: "error",
                        border: "left",
                        prominent: "",
                        "max-width": "800",
                      },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(_vm.$t("PaymentPage.Checkout.invalidOrder")) +
                          " "
                      ),
                      _c(
                        "router-link",
                        {
                          staticClass: "white--text font-weight-bold",
                          attrs: { to: { name: "Subscription Plan" } },
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t("PaymentPage.Checkout.returnToPricingPage")
                            )
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "auth-layout-footer" },
            [_c("client-footer-component")],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }